export { ReactComponent as ClearTextStyle } from './svgs/clear-text-style.svg';
